
export const LOGIN_CHAT = 'LOGIN_CHAT';
export const LOGOUT_CHAT = 'LOGOUT_CHAT';

export const UPDATE_ERR = 'UPDATE_ERR';




// WEBPACK FOOTER //
// ./src/stores/mutation_types.js